import api from '@/api/axios/main.api'

export const fetchAllTopic = () => {
  return api.get('/api/topic/all-admin')
}
